// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { SectionOut } from './sectionOut.zod.ts';

export const SectionsOut = zod.object({
  "revision": zod.int(),
  "sections": zod.array(SectionOut)
});

export type SectionsOut = zod.input<typeof SectionsOut>;
export type SectionsOutOutput = zod.output<typeof SectionsOut>;
